import { h, Component } from "preact";
import { css } from "emotion";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import Page from "../../components/Page";
import Content from "../../components/Content";
import CountDown from "../../components/CountDown";
import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";
import BookingHeader from "../../components/BookingHeader";
import YourOrder from "../../components/YourOrder";
import WarningMessage from "../../components/WarningMessage";
import TwoCols from "../../components/TwoCols";
import { getEvent } from "../../state/actions/eventActions";
import { getOrder } from "../../state/actions/orderActions";
import {
  listMerchandise,
  createMerchandiseOrder,
  getMerchandise
} from "../../state/actions/merchandiseActions";
import { loadSummary } from "../../state/actions/orderSummaryActions";
import MerchandiseCard from "./MerchandiseCard";
import { pageChange } from "../../utils/BrowserUtils";
import { determineManualOrder } from "../../utils/ManualOrderUtils";

const formName = "merchandise";

class Merchandise extends Component {
  constructor() {
    super();
    this.createMerchandise = this.createMerchandise.bind(this);
  }

  componentDidMount() {
    const {
      orderId,
      getEvent,
      eventSlug,
      listMerchandise,
      getMerchandise,
      merchandise,
      event,
      order
    } = this.props;
    if (!event.data && !event.loading) {
      getEvent(eventSlug, undefined, false, orderId);
    }
    if (!merchandise.listMerch.data && !merchandise.listMerch.loading) {
      listMerchandise(orderId);
      getMerchandise(orderId);
    }
    pageChange("Merchandise", event);
  }

  getMerchSelected(merch) {
    if (!merch) {
      return 0;
    }
    const numberSelected = merch.reduce((total, item) => {
      const optionsSelected = item.options.reduce((total, option) => {
        const quantity = option.quantity ? option.quantity : 0;
        return total + quantity;
      }, 0);
      return total + optionsSelected;
    }, 0);
    return numberSelected;
  }

  componentDidUpdate(prevProps) {
    const {
      merchOrder,
      loadSummary,
      event,
      ticketSelection,
      order,
      merchandise
    } = this.props;
    if (!merchandise.merch.loading) {
      const lastMerchLength = this.getMerchSelected(prevProps.merchOrder);
      const merchLength = this.getMerchSelected(merchOrder);

      if (merchLength !== lastMerchLength) {
        loadSummary(
          event.id,
          ticketSelection.tickets,
          order.data.clientDonation,
          order,
          merchOrder
        );
      }
    }
  }

  createMerchandise(merchData) {
    const { order, event, createMerchandiseOrder } = this.props;
    createMerchandiseOrder(
      event.data.slug,
      order.data._id,
      merchData.merchOrder
    );
  }

  render({ event, merchandise, merchOrder, order }) {
    const isManualOrder = determineManualOrder();
    if (event.loading || !event.data) {
      return <Page />;
    }
    if (event.data.suspendSales && !isManualOrder) {
      return (
        <Page background={true} border={true}>
          <Content>
            <WarningMessage
              title="Ticket Sales Unavailable"
              message="Ticket sales have ended"
            />
          </Content>
        </Page>
      );
    }
    if (!event.data.validDates.length && !isManualOrder) {
      return (
        <Page background={true} border={true}>
          <Content>
            <WarningMessage title="Ticket Sales Unavailable" />
          </Content>
        </Page>
      );
    }
    return (
      <Page>
        <Content>
          <BookingHeader />
          <TwoCols>
            <div>
              {/* {merchandise && merchandise.listMerch && merchandise.listMerch.error ? (
                <p class="text-error">{merchandise.listMerch.error.message}</p>
              ) : null} */}
              {merchandise.listMerch.loading ||
              merchandise.merch.loading ||
              event.loading ||
              !event.data ||
              !order.data ? (
                <div class="loading loading-lg" />
              ) : (
                <div>
                  <MerchForm
                    merchandise={merchandise}
                    merchOrder={merchOrder}
                    createMerchandise={this.createMerchandise}
                  />
                </div>
              )}
            </div>
            {!order.data || !event.data ? (
              <div class="loading loading-lg" />
            ) : (
              <YourOrder allowDiscountsAdd={false} />
            )}
          </TwoCols>
        </Content>
      </Page>
    );
  }
}

let MerchForm = ({
  merchandise,
  merchOrder,
  createMerchandise,
  handleSubmit
}) => {
  const { listMerch, merch } = merchandise;
  const { data } = listMerch;
  if (!merchOrder) {
    return <div class="loading loading-lg" />;
  }
  const topLineStyle = css({
    borderBottom: "solid 1px",
    borderColor: "#dedede",
    marginBottom: 15
  });
  return (
    <form onSubmit={handleSubmit(createMerchandise)}>
      <h2>Add-ons</h2>
      <div className={topLineStyle}>
        <CountDown />
        {merch.error ? (
          <div
            style={{
              fontSize: 12,
              color: "#DD1C1C",
              textAlign: "left"
            }}
          >
            {merch.error}
          </div>
        ) : null}
      </div>
      <div>
        {data.map((merch, index) => {
          return (
            <MerchandiseCard
              {...merch}
              merchOrder={merchOrder[index]}
              index={index}
            />
          );
        })}
      </div>
      <ActionBar>
        <ActionButton
          disabled={merch.loading}
          loading={merch.loading}
          dataCY="EnterDetails"
        >
          Enter Details
        </ActionButton>
      </ActionBar>
    </form>
  );
};

const selector = formValueSelector(formName);

MerchForm = reduxForm({
  form: formName,
  destroyOnUnmount: true,
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(MerchForm);

MerchForm = connect(
  state => {
    let initialValues = {
      merchOrder: (state.merchandise.listMerch.data || []).map(merch => {
        let selectedOption = 0;
        if (merch.merchandiseOptions.length > 1) {
          selectedOption = undefined;
          merch.merchandiseOptions.forEach((opt, i) => {
            if (selectedOption === undefined && !opt.soldOut) {
              selectedOption = i;
            }
          });
        }
        return {
          merchandiseTypeId: merch._id,
          selectedOption: selectedOption,
          merchandiseTypeName: merch.itemName,
          options: merch.merchandiseOptions.map(opt => {
            return {
              merchandiseOptionId: opt._id,
              merchandiseOptionName: opt.optionName,
              quantity: 0,
              price: opt.price
            };
          })
        };
      })
    };
    state.merchandise.merch.data.forEach(merch => {
      const foundMerch = initialValues.merchOrder.find(
        m => m.merchandiseTypeId === merch.merchandiseTypeId
      );
      if (foundMerch) {
        const foundOpt = foundMerch.options.find(
          opt => opt.merchandiseOptionId === merch.merchandiseOptionId
        );
        if (foundOpt) {
          foundOpt.quantity = foundOpt.quantity + 1;
        }
      }
    });
    return {
      initialValues: initialValues
    };
  },
  {}
)(MerchForm);

export default connect(
  state => ({
    event: state.event,
    order: state.order,
    merchandise: state.merchandise,
    merchOrder: selector(state, "merchOrder"),
    ticketSelection: state.ticketSelection
  }),
  {
    getEvent,
    listMerchandise,
    getOrder,
    loadSummary,
    createMerchandiseOrder,
    getMerchandise
  }
)(Merchandise);



// WEBPACK FOOTER //
// ./routes/merchandise/Merchandise.js